import React, { Component } from "react";
import { Form, Modal } from "reactstrap";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Cargando from '../../../../components/Generales/ModalCargando';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Globales from "utils/Globales";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import { Save, Clear, Search, Check, ArrowForward, ArrowForwardIos, DesktopAccessDisabledSharp, LocalConvenienceStoreOutlined } from "@material-ui/icons";
import moment from 'moment';
import cookie from 'js-cookie'

class calificacionTOEFL {
  Comentarios = "";
  Estado = "";
  FechaCalifico = new Date();
  FechaExamen = new Date();
  FechaRegistro = new Date();
  Listening = -1;
  Reading = -1;
  Structure = -1;
  Total = -1;
  _id = "";
  idAlumno = "";
  idCita = "";
  idExpediente = "";
}

const validarSC = (calificacion) => {
  let numCalificacion = parseInt(calificacion)
  if (numCalificacion >= 0) {
    return numCalificacion
  }
  return "SC"
}

const NIVELES_CAMBRIDGE = Object.freeze({
  A1: -11,
  A2: -12,
  B1: -21,
  B2: -22,
  C1: -31,
})

const centerY = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}

class ModalCalificarGrupo extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      MostrarModal: false,
      _id: '',
      Calificacion: new calificacionTOEFL(),
      NombreNivel: "",
      InfoGrupo: {},
      CalificacionUnidades: [],
      ListaAlumnos: [],
      UnidadesLibro: [],
      ListaNiveles: [],
      UnidadesLibroActuales: [],
      errorObservaciones: false,
      disabled: false,
      colorNotificacion: "success",
      mensaje: "",
      br: false,
      DesactivarBoton: false,
      NombreGuardado: '',
      SubcategoriaHabilitada: false,
      aviso: "",
      CuerpoCargando: "Cargando",
      cargando: false,
      esCambridge: false,
      valoresNumericosCambridge: Object.values(NIVELES_CAMBRIDGE),

    }
    this.closeModal = this.closeModal.bind(this);
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick();
    }
  }

  componentDidMount() {
    this.ObtenerCalificaiconesExpediente()
  }

  async ObtenerCalificaiconesExpediente() {
    this.setState({ cargando: true });
    await fetch(Globales.Url + 'Toefl/Toefl/ObtenerCalificacionToefl', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ idExpediente: this.props.idExpediente })
    }).then(res => res.json())
      .then(data => {
        //console.log("ObtenerInformacionGrupo: ", data.data);
        if (data.error) { //Error en la respuesta
          this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", cargando: false });
          this.showNotification();
        } else { //Filtrado exitoso

          this.setState({
            Calificacion: this.FormatearCalificacionesRecepcion(data.data), 
            cargando: false
          })
        }
      })
      .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
  }

  CrearObjLogGuardar() {
    let IDcookie = JSON.parse(cookie.get('id'));
    let Log = {};
    let aux = [];
    Log = {
      Fecha: moment(new Date()).format("YYYY-MM-DD"),
      _idGrupo: this.state.InfoGrupo._id,
      _idIdioma: this.state.InfoGrupo._idIdioma,
      _idMaestro: this.state.InfoGrupo._idMaestro,
      _idUsuario: IDcookie
    }

    this.state.CalificacionUnidades.map(calif => {
      let califGuardar = JSON.parse(JSON.stringify(calif));
      if (calif.CalificacionAsignada == "SC") {
        califGuardar.CalificacionAsignada = -1
      }

      aux.push(califGuardar);
    })

    //console.log(aux)

    this.CalificarUnidadAlumnos(aux, Log)
  }

  async CalificarUnidadAlumnos() {
    this.setState({ cargando: true });

    let calificacion = this.FormatearCalificacionesEnvio()
    await fetch(Globales.Url + 'Toefl/Toefl/CalificarExpedienteTOEFL', {
      method: 'POST',
      headers: {
        Accept: 'application/json', 'Content-Type': 'application/json', 'Authorization': Globales.token
      }
      , body: JSON.stringify({ calificacion: calificacion, })
    }
    ).then(res => res.json())
      .then(data => {
        console.log("API", data);
        if (data.error) { //Error en la respuesta
          this.setState({ mensaje: data.mensaje, colorNotificacion: "danger", ListaAlumnos: [], Activo: 1, cargando: false });
          this.showNotification();
        } else { //Filtrado exitoso
          this.setState({ cargando: false })
          this.props.eventClick(data.mensaje);
        }
      })
      // .catch(err => this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true }));
      .catch(err => {
        console.error(err);
        this.setState({ mensaje: "Ocurrió un error inesperado, por favor inténtelo de nuevo", colorNotificacion: "danger", br: true, CuerpoCargando: "Error", cargando: true })
      });
  }
  FormatearCalificacionesEnvio() {
    let calificacion = this.state.Calificacion

    if (!(calificacion.Structure > 0)) calificacion.Structure = -1
    if (!(calificacion.Reading > 0)) calificacion.Reading = -1
    if (!(calificacion.Listening > 0)) calificacion.Listening = -1
    if (!(calificacion.Total > 0)) calificacion.Total = -1

    return calificacion
  }
  FormatearCalificacionesRecepcion(calificacion) {
    calificacion.Structure = validarSC(calificacion.Structure)
    calificacion.Reading = validarSC(calificacion.Reading)
    calificacion.Listening = validarSC(calificacion.Listening)
    calificacion.Total = validarSC(calificacion.Total)

    return calificacion
  }

  // Regresar datos hacia afuera del modal ***********************************************************************************************************
  closeModal() {
    this.props.eventClick("esc");
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  handleChangeEdit = (e) => {
    const { name, value } = e.target;

    let auxCalificaciones = this.state.Calificacion
    auxCalificaciones[name] = value

    this.setState({ Calificacion: auxCalificaciones });
  }

  handleFocus = (event) => {
    const e = event.target;
    e.select()
  }

  handleBlur = (e) => {
    const { name } = e.target;

    let auxCalificaciones = this.state.Calificacion;

    auxCalificaciones[name] = validarSC(auxCalificaciones[name])

    this.setState({ Calificacion: auxCalificaciones });
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  cerrarModal = () => {
    this.props.eventClick("esc")
  }

  render() {
    let agregar;
    if (this.state.cargando == true) {
      agregar = (
        <Cargando
          Cuerpo={this.state.CuerpoCargando}
          show={this.state.cargando}
        />
      );
    }

    return (
      <div>
        <Modal
          isOpen={this.props.show}
          className="static-modal"
          size="lg"
          backdrop={"static"}
          style={{ width: "100%", maxHeight: "100%" }}
        >
          <Card>
            <CardHeader color="info">Calificar examen TOEFL</CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <p style={{ fontWeight: "bold" }}>-1 = Sin Calificación / No Aplica</p>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem style={centerY} xs={12} sm={12} md={4}>
                  <span>Listening Comprehension</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <TextField
                    fullWidth variant="outlined" type="text" size="small"
                    onChange={this.handleChangeEdit}
                    onBlur={this.handleBlur}
                    InputProps={{
                      onFocus: this.handleFocus.bind(this),
                      value: this.state.Calificacion.Listening,
                      name: "Listening",
                    }}
                  />
                </GridItem>
                <GridItem style={centerY} xs={12} sm={12} md={4}>
                  <span>Structure & Written Expression</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <TextField
                    fullWidth variant="outlined" type="text" size="small"
                    onChange={this.handleChangeEdit}
                    onBlur={this.handleBlur}
                    InputProps={{
                      onFocus: this.handleFocus.bind(this),
                      value: this.state.Calificacion.Structure,
                      name: "Structure",
                    }}
                  />
                </GridItem>
                <GridItem style={centerY} xs={12} sm={12} md={4}>
                  <span>Reading Comprehension</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <TextField
                    fullWidth variant="outlined" type="text" size="small"
                    onChange={this.handleChangeEdit}
                    onBlur={this.handleBlur}
                    InputProps={{
                      onFocus: this.handleFocus.bind(this),
                      value: this.state.Calificacion.Reading,
                      name: "Reading",
                    }}
                  />
                </GridItem>
                <GridItem style={centerY} xs={12} sm={12} md={4}>
                  <span>Total Score</span>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <TextField
                    fullWidth variant="outlined" type="text" size="small"
                    onChange={this.handleChangeEdit}
                    onBlur={this.handleBlur}
                    InputProps={{
                      onFocus: this.handleFocus.bind(this),
                      value: this.state.Calificacion.Total,
                      name: "Total",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <br />
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    size="small"
                    multiline
                    rows={3}
                    onChange={this.handleChangeEdit}
                    InputProps={{
                      onFocus: this.handleFocus.bind(this),
                      value: this.state.Calificacion.Comentarios,
                      name: "Comentarios",
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
          <GridItem xs={12} sm={12} md={12}>
            <Button color="info" disabled={this.state.disabled} tabIndex="1" size='sm' className='pull-right mr-2 mb-3' round onClick={() => this.CalificarUnidadAlumnos()}><Save />&nbsp;Guardar</Button>
            <Button tabIndex="1" size='sm' className='pull-right mr-2 mb-3' round onClick={() => this.props.eventClick("esc")}><Clear />&nbsp;Cancelar</Button>
          </GridItem>
        </Modal>
        <div>
          {agregar}
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(basicsStyle)(ModalCalificarGrupo);